import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.dynamicClasses, "inline-flex w-full justify-between group text-gray-900 px-4 py-2 text-sm font-normal hover:font-medium leading-5 focus:outline-none transition-all duration-100"])
    }, [
      _renderSlot(_ctx.$slots, "default"),
      _withDirectives((_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["h-5 w-5", _ctx.loading ? 'text-gray-600' : 'text-blue-600 group-hover:text-white']),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true"
      }, _hoisted_2, 2)), [
        [_vShow, _ctx.active]
      ])
    ], 2)
  ]))
}